import './SettingsBulkFilterZip.scss'

import React, {Component} from 'react';
import { Button, Modal } from 'react-bootstrap'
import { replace } from 'react-router-redux'

import { show as showModal, connectModal } from 'redux-modal'

import { fetchUnblockedZipcodes, bulkAddZipFilter } from 'manager/redux/settings'
import { getMetroFromZip } from 'manager/util/helper'

class Confirm extends Component {

  constructor(props) {
    super(props)
    this.handleSave = this.handleSave.bind(this)
  }

  handleSave() {
    this.props.dispatch(bulkAddZipFilter(this.props.zips_to_block.map((zip) => zip.name)))
    this.props.dispatch(replace({pathname: '/settings/location'}))
  }

  render() {
    const zipcode_list = <div> {this.props.zips_to_block.map((zip, idx) => {
      return <div key={idx}>{zip.name} - {zip.metro}</div>
    })}
    </div>

    return (
      <Modal className="ConfirmModal" show={this.props.show}>
        <Modal.Header>
          <div className="ConfirmModal__header">
          <span className="ConfirmModal__header-title">Confirm Disabled Zip Codes</span>
          <span className="ConfirmModal__header-exit" onClick={this.props.handleHide} />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="ConfirmModal__body-header">Before you leave, confirm that you want to disable the following zip codes:</div>
          {zipcode_list}
        </Modal.Body>
        <Modal.Footer>
          <div classNam="ConfirmModal__footer">
            <Button className="ConfirmModal__footer-cancel pull-left" onClick={this.props.handleHide}>Cancel</Button>
            <Button className="ConfirmModal__footer-confirm" bsStyle="primary" onClick={this.handleSave}>Confirm</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}
const ConfirmModal = connectModal({ name: 'ConfirmModal', destroyOnHide: true })(Confirm)

class SettingsBulkFilterZip extends Component {

  constructor(props) {
    super(props)

    this.state = {
      'staged_zips': []
    }

    this.handleSave = this.handleSave.bind(this)
    this.redirectToLocation = this.redirectToLocation.bind(this)
    this.stageZipcode = this.stageZipcode.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(fetchUnblockedZipcodes())
  }

  handleSave() {
    if (this.state.staged_zips.length > 0) {
      this.props.dispatch(bulkAddZipFilter(this.state.staged_zips.map((zip) => zip.name)))
    }
    this.props.dispatch(replace({pathname: '/settings/blocked-zipcodes'}))
  }

  redirectToLocation() {
    if (this.state.staged_zips.length > 0) {
      this.props.dispatch(showModal("ConfirmModal", {'zips_to_block': this.state.staged_zips, 'dispatch': this.props.dispatch}))
    } else {
      this.props.dispatch(replace({pathname:'/settings/location'}))
    }
  }

  stageZipcode(zipcode, staged) {
    if (staged) {
      this.setState({'staged_zips': this.state.staged_zips.filter(x => x !== zipcode)})
    } else {
      this.setState({'staged_zips': [...this.state.staged_zips, zipcode]})
    }
  }


  render() {
    const { auth, settings } = this.props
    const isEmerging = auth.user.agent_experience_level === 'emerging'
    const unblockedZipcodes = settings.unblocked_zipcodes ? <div className="SettingsBulkFilterZip__unblocked_zipcodes-list">
      { settings.unblocked_zipcodes.map((zip, idx) => {
        const staged = this.state.staged_zips.indexOf(zip) !== -1
        return <button className="SettingsBulkFilterZip__unblocked_zipcodes-item" key={idx} onClick={() => this.stageZipcode(zip, staged)}>
          <div className="SettingsBulkFilterZip__unblocked_zipcodes-item-check">{staged ? <i className="fa fa-check" aria-hidden="true"></i> : null}</div>
          <div className="SettingsBulkFilterZip__unblocked_zipcodes-item-label">{zip.name} - {getMetroFromZip(zip)}</div>
        </button>
      })}
    </div> : null

    return <div className="SettingsBulkFilterZip">
      <div className="SettingsBulkFilterZip__subtitle">
        <span className="SettingsBulkFilterZip__subtitle-normal">Select the zip codes within your coverage area from which you </span>
        <span className="SettingsBulkFilterZip__subtitle-bold">no longer want to receive referrals</span>
      </div>
      <div className="SettingsBulkFilterZip__unblocked_zipcodes">
        {unblockedZipcodes}
      </div>
      <div className="SettingsBulkFilterZip__footer">
        <div>Not seeing enough zip codes?</div>
        <div><a onClick={this.redirectToLocation}>Increase your Coverage Area</a></div>
      </div>
      <div className="SettingsBulkFilterZip__save">
        <Button bsStyle="success" disabled={isEmerging} onClick={this.handleSave}>Save</Button>
      </div>
      <ConfirmModal />
    </div>
  }
}

export default SettingsBulkFilterZip
